import React from 'react';
import { useNavigate } from 'react-router-dom';
import useOperationalStore from '../store/useOperationalStore';
import { ICONS, FLOW_LENSES } from './navConfig';
import './FlowSwitcher.css';

// Segmented lens switcher inside the Flow workspace. Seven lenses over the
// same live job set — this replaces the sidebar nav items they used to be.
// Views not listed here (command, history, road-service) stay reachable via
// ?view= URLs. `bare`: drop the outer bar chrome (background/border/padding)
// when nesting inside another toolbar (e.g. FlowView's own toolbar) instead
// of rendering as its own header row.
export default function FlowSwitcher({ bare = false }) {
  const activeView    = useOperationalStore(s => s.activeView);
  const setActiveView = useOperationalStore(s => s.setActiveView);
  const navigate = useNavigate();

  function go(id) {
    setActiveView(id);
    navigate(`/flow?view=${id}`, { replace: true });
  }

  return (
    <div className={`flow-switcher${bare ? ' flow-switcher--bare' : ''}`} role="tablist" aria-label="Flow views">
      {FLOW_LENSES.map(lens => (
        <button
          key={lens.id}
          role="tab"
          aria-selected={activeView === lens.id}
          className={`flow-lens${activeView === lens.id ? ' flow-lens--active' : ''}`}
          onClick={() => go(lens.id)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            {ICONS[lens.icon]}
          </svg>
          {lens.label}
        </button>
      ))}
    </div>
  );
}
